/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useRef, useState } from "react";
import GaugeChart from "react-gauge-chart";
import { useSelector } from "react-redux";
// reactstrap components
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import { BASE_URL } from "../utils/constants";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";

var getSchGrades = (originArr = []) => {
  let grdsArr = [];
  originArr.forEach((section) => {
    section.period.forEach((period) => {
      period.assignment.forEach((ass) => {
        grdsArr.push(ass);
      });
    });
  });
  return grdsArr;
};

const Courses = () => {
  const [coursesStatistics, setCoursesStatistics] = useState([]);
  const [courseFilter, setCourseFilter] = useState("current");
  const [ishold , setIshold] = useState(0)
  const requestIdRef = useRef(0);
  useEffect(() => {
    getCourses(courseFilter);
  }, [courseFilter]);

  const normalizePerformance = (performance) => {
    const parsedPerformance = parseFloat(performance);

    if (!Number.isFinite(parsedPerformance) || parsedPerformance < 0) {
      return null;
    }

    return Math.min(parsedPerformance / 100, 1);
  };
  
  const getCourses = async (filter) => {
    const requestId = ++requestIdRef.current;
    Swal.showLoading();
    try {
     
      setCoursesStatistics([]);
      let res = await axios.post(
        `${BASE_URL}/student/getcoursesandperformance.php`,
        {
          filter,
        }
      );
      if (requestId !== requestIdRef.current) return;
     
      const nextCourseDetails = [];

      res.data.data.response.courses.forEach((course) => {
        nextCourseDetails.push({
          id: course.id,
          name: course.coursename,
          // exams: gradess,
          performance: normalizePerformance(course?.performance),
        });
      });

      setIshold(res.data.data.ishold)

      

      setCoursesStatistics(nextCourseDetails);
    } catch (e) {
      if (requestId !== requestIdRef.current) return;
      Swal.fire("Error while getting courses", "", "error");
    } finally {
      if (requestId !== requestIdRef.current) return;
      Swal.close();
    }
  };

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col md={12}>
            <Card>
              <CardHeader>
                <h4 className="title">Courses</h4>
              </CardHeader>
              <CardBody className="all-icons">
                <div>
                  <div className="form-check form-check-inline ">
                    <input
                      style={{ marginRight: "-20%" }}
                      className="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      checked={courseFilter === "current"}
                      onChange={(e) => {
                        setCourseFilter("current");
                      }}
                      value="option1"
                    />
                    <label className="form-check-label" htmlFor="inlineRadio1">
                      Current Courses
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      style={{ marginRight: "-20%" }}
                      className="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      onChange={(e) => {
                        setCourseFilter("archived");
                      }}
                      id="inlineRadio2"
                      checked={courseFilter === "archived"}
                      value="option2"
                    />
                    <label className="form-check-label" htmlFor="inlineRadio2">
                      Archived Courses
                    </label>
                  </div>
                </div>
                <Row>
                {
                  ishold == 1? (
                    <Col md={12}>
                     <h4 style={{color:"red"}} className='row col-12 m-5'> Please pay the overdue installment first to access your GradeBook. </h4>
                    </Col>
                  ):coursesStatistics?.map((course, key) => {
                  
                    return (
                      <Col
                        lg={4}
                        sm={6}
                        xs={12}
                        className="font-icon-list"
                        key={key}
                        style={{ textAlign: "center" }}
                      >
                        <Link to={`/course/${course.id}`}>
                          <div className="font-icon-detail bg-dark py-2 px-0">
                            <h5 style={{ fontWeight: "bold" }}>
                              {course?.name}
                            </h5>
                            <h5>Overall Performance</h5>
                            <h5>
                              {course?.performance === null
                                ? "Not available"
                                : `${Math.round(course.performance * 100)}%`}
                            </h5>
                            <GaugeChart
                              id={`gauge-chart-${course.id}`}
                              nrOfLevels={20}
                              percent={course?.performance ?? 0}
                              needleColor="#3452f5"
                              style={{
                                height: "60%",
                                width: "80%",
                                margin: "0 auto",
                              }}
                            />
                          </div>
                        </Link>
                      </Col>
                    );
                  })
                }
              
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Courses;
